import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Grid } from '@/components/Grid';
import type { Maybe } from '@/lib/types';

import { visibilityControl } from '../../Card.styles';

export const Wrapper = styled(Box)<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
  backgroundColor: Maybe<string>;
}>`
  position: relative;
  overflow: hidden;
  padding: 20px;
  ${({ backgroundColor }) => css`
    background-color: ${backgroundColor};
  `}
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
`;
export const ColumnsTextContent = styled(Grid)<{ textAlignment: string }>`
  margin-top: 16px;
  ${({ theme, textAlignment }) => css`
    grid-gap: 0px;
    grid-template-columns: 1fr;
    text-align: ${textAlignment};
    ${theme.media.md.up} {
      grid-gap: 40px;
      grid-template-columns: repeat(2, 1fr);
    }
  `}
`;
